var map = {
	"./ambiente-1.jpg": 345,
	"./ambiente-2.jpg": 750,
	"./ambiente-3.jpg": 5707,
	"./bolsa-de-trabajo.jpg": 6761,
	"./contacto.jpg": 3597,
	"./invertir.jpg": 723,
	"./png/botella.png": 9873,
	"./png/cata-mezcalera.png": 2834,
	"./png/mezcalita.png": 7780,
	"./png/nachos.png": 6638,
	"./png/serpiente.png": 2307,
	"./png/shot-alacran.png": 3895,
	"./square-sucursal-lagos-de-moreno.jpg": 9950,
	"./square-sucursal-manzanillo.jpg": 2352,
	"./square-sucursal-rio-nilo.jpg": 8708,
	"./square-sucursal-san-mateo.jpg": 20,
	"./square-sucursal-tetlan.jpg": 4047
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5700;